/**
 * A rejected command, carrying the code the transport turns into a status.
 *
 * Its own module so command handlers can throw it without importing the reducer that dispatches them.
 */
export class CommandError extends Error {
    code;
    constructor(code, message) {
        super(message);
        this.name = 'CommandError';
        this.code = code;
    }
}
//# sourceMappingURL=errors.js.map